export const GENERATE_INVOICE_SUCCESSFUL = 'GENERATE_INVOICE_SUCCESSFUL'
export const GENERATE_INVOICE_FAILED = 'GENERATE_INVOICE_FAILED'
export const UPDATE_INVOICE_FORM_SUCCESSFUL = 'UPDATE_INVOICE_FORM_SUCCESSFUL'
export const UPDATE_INVOICE_FORM_FAILED = 'UPDATE_INVOICE_FORM_FAILED'
export const CLEAR_INVOICE_FORM_SUCCESSFUL = 'CLEAR_INVOICE_FORM_SUCCESSFUL'
export const CLEAR_INVOICE_FORM_FAILED = 'CLEAR_INVOICE_FORM_FAILED'